import React from "react";
import "./loader.css";

const Loader = ({
  message,
  submessage,
  fullscreen = true,
  progress,
  showBackdrop = true,
}) => {
  return (
    <div
      className={`loader-wrapper ${fullscreen ? "fullscreen" : ""} ${
        showBackdrop ? "backdrop" : ""
      }`}
    >
      <div className="loader-spinner" />
      {message && <p className="loader-message">{message}</p>}
      {submessage && <p className="loader-submessage">{submessage}</p>}
      {typeof progress === "number" && (
        <div className="loader-progress">
          <div className="loader-progress-bar" style={{ width: `${progress}%` }} />
        </div>
      )}
    </div>
  );
};

export default Loader;
